import { apiClient } from '../_helpers';

export const todoService = {
  getAll,
  searchTodos,
  getById,
  addTodo,
  updateTodo,
  deleteTodo
};

function getAll() {
  return apiClient('todos/')
  .get()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function searchTodos(qry) {
  return apiClient(`todos?searchQuery=${qry}`)
  .get()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function getById(id) {
  return apiClient('todos/')
  .get(`${id}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function addTodo(newtodo) {
  return apiClient('todos/')
  .post('',`${JSON.stringify(newtodo)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function updateTodo(newtodo) {
  return apiClient(`todos/${newtodo.id}`)
  .put('',`${JSON.stringify(newtodo)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function deleteTodo(todo) {
  return apiClient(`todos/${todo}`)
  .delete()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}